import { useMemo } from 'react'
import { useFetchObjectiveKnowledgeModelQuery } from '@/features/km/objectiveKnowledgeModelsApi'
import { useKnowledgeModelSettings } from '@/features/km/useKnowledgeModelSettings'

type Props = {
  aggregateId?: string
  skip: boolean
  isCourseDetail: boolean
}

export const useKnowledgeModelId = ({ aggregateId, skip, isCourseDetail }: Props) => {
  const settings = useKnowledgeModelSettings()

  const {
    data: responseKM,
    isLoading: loadingKM,
    error: errorKM,
  } = useFetchObjectiveKnowledgeModelQuery(aggregateId!, {
    skip,
    refetchOnMountOrArgChange: true,
  })

  const knowledgeModelId = useMemo(() => {
    if (loadingKM || !settings?.enabled) {
      return
    }

    if (isCourseDetail) {
      if (errorKM) {
        return settings?.defaultKnowledgeModelId?.trim?.()
      }

      return responseKM?.knowledgeModelId || settings?.defaultKnowledgeModelId?.trim?.()
    }

    return settings.defaultKnowledgeModelId?.trim?.()
  }, [
    errorKM,
    isCourseDetail,
    loadingKM,
    responseKM?.knowledgeModelId,
    settings.defaultKnowledgeModelId,
    settings?.enabled,
  ])

  return { knowledgeModelId }
}
